import get from "lodash/get";

interface OriginResponse<T> {
  /** 是否处理成功 */
  success?: boolean;
  /** 返回结果 */
  result?: T;
  /** 错误码 */
  error_code?: number;
  /** 错误信息 */
  error_msg?: string;
  /** 错误码 */
  errorCode?: number;
  /** 错误信息 */
  errorMsg?: string;
}

export default class LocalResponse<T> {
  // eslint-disable-next-line default-param-last
  static error<T = any>(error_msg = "网络故障", ori_response?: Response) {
    return new LocalResponse<T>({ error_msg }, ori_response);
  }

  /** 原始响应 */
  ori_response: Response | undefined;

  /** 是否处理成功 */
  result = false;

  /** 返回结果 */
  data = {} as T;

  /** 错误码（取决于接口返回格式及是否额外处理了接口返回值） */
  error_code = 0;

  /** 错误信息（取决于接口返回格式及是否额外处理了接口返回值） */
  error_msg = "";

  /** 错误码（取决于接口返回格式及是否额外处理了接口返回值） */
  errorCode = 0;

  /** 错误信息（取决于接口返回格式及是否额外处理了接口返回值） */
  errorMsg = "";

  /**
   * 考虑非omsapi接口的返回情况
   */
  [key: string]: any;

  // eslint-disable-next-line default-param-last
  constructor(res: OriginResponse<T> = {}, oriResponse?: Response) {
    Object.assign(this, res);
    this.ori_response = oriResponse;
    this.oriResponse = oriResponse;
  }

  /**
   * 获取某个特定字段的值
   * @param path
   * @param defaultValue
   */
  get<U>(path: string, defaultValue?: U) {
    return get(this.data, path, defaultValue) as U;
  }
}
